
import React from "react";
import { IndustryIntegrationPanel } from "@/components/script-editor/industry/IndustryIntegrationPanel";

export default function IndustryIntegrationPage() {
  return (
    <div className="py-4">
      <IndustryIntegrationPanel scriptId="" />
    </div>
  );
}
